<div class="hover-anchor text-primary"
  [satPopoverAnchor]="p"
  (mouseenter)="p.open()"
  (mouseleave)="p.close()">
  {{index}}
</div>

<sat-popover #p horizontalAlign="after">
  <div class="tooltip-wrapper">
    <table class="table table-sm table-striped table-dark m-0">
      <thead><tr><td>Name</td><td>Register</td><td>Value</td></tr></thead>
      <tbody>
        @for (row of registers; track row) {
          <tr>
            <td>{{row.name}}</td>
            <td>{{row.register}}</td>
            <td>{{row.value}}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</sat-popover>
